import Nav from "./Nav";
import Footer from "./Footer";

/**
 * Public layout. Nav is `position: fixed` so the home hero can bleed to the
 * top of the viewport under a transparent nav. Every non-hero page needs
 * padding equal to the nav height so its content doesn't hide under the bar;
 * the home hero cancels that padding with `-mt-[52px] md:-mt-[56px]` (see
 * Home.jsx).
 */
export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Nav />
      <main
        className="flex-1 pt-[52px] md:pt-[56px]"
        data-testid="site-main"
      >
        {children}
      </main>
      <Footer />
    </div>
  );
}
